import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "@/components/Header";
import { useAuth } from "@/contexts/AuthContext";
import { useLang } from "@/contexts/LangContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const { t } = useLang();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("OK");
      nav("/app");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFAFA]" data-testid="login-page">
      <Header />
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16 md:py-24 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5 md:col-start-2">
          <div className="font-mono-tech text-xs tracking-[0.3em] uppercase text-[#D90429] mb-6">
            · ACCESO RESTRINGIDO
          </div>
          <h1 className="font-serif-display text-5xl md:text-6xl font-bold tracking-tighter leading-none mb-10">
            {t("auth_login_title")}
          </h1>
          <form onSubmit={submit} className="space-y-8" data-testid="login-form">
            <div>
              <label className="font-mono-tech text-[10px] tracking-[0.3em] uppercase text-[#A3A3A3] block mb-2">
                {t("auth_email")}
              </label>
              <input
                data-testid="login-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-transparent border-b border-[#0A0A0A] px-0 py-3 text-lg focus:outline-none focus:border-[#D90429]"
                autoComplete="email"
              />
            </div>
            <div>
              <label className="font-mono-tech text-[10px] tracking-[0.3em] uppercase text-[#A3A3A3] block mb-2">
                {t("auth_password")}
              </label>
              <input
                data-testid="login-password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-transparent border-b border-[#0A0A0A] px-0 py-3 text-lg focus:outline-none focus:border-[#D90429]"
                autoComplete="current-password"
              />
            </div>
            <button
              data-testid="login-submit"
              disabled={loading}
              className="w-full bg-[#0A0A0A] text-white py-4 font-mono-tech text-xs uppercase tracking-[0.3em] border border-[#0A0A0A] hover:bg-[#D90429] hover:border-[#D90429] transition-colors disabled:opacity-50"
            >
              {loading ? "···" : t("auth_submit_login")}
            </button>
            <div className="font-mono-tech text-xs uppercase tracking-widest text-[#404040]">
              {t("auth_no_account")}{" "}
              <Link to="/register" className="underline underline-offset-4 hover:text-[#D90429]" data-testid="link-to-register">
                {t("nav_register")}
              </Link>
            </div>
          </form>
        </div>
        <aside className="hidden md:flex md:col-span-5 bg-[#0A0A0A] text-white p-12 flex-col justify-between">
          <div className="font-mono-tech text-[10px] tracking-[0.3em] uppercase opacity-60">
            · ID-0042 · CLEARANCE LEVEL · ACADEMIC
          </div>
          <blockquote className="font-serif-display italic text-3xl leading-snug">
            “El discurso político no se mide por su verdad, sino por la arquitectura estratégica que oculta.”
            <footer className="font-mono-tech text-[10px] tracking-[0.3em] uppercase mt-6 text-[#D90429] not-italic">
              — MICHAEL A. GALASCIO
            </footer>
          </blockquote>
          <div className="font-mono-tech text-[10px] tracking-[0.3em] uppercase opacity-60">
            🔬 GalascioDAS™
          </div>
        </aside>
      </div>
    </div>
  );
}
